var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex thick-border px-2 min py-1",class:[_vm.border, _vm.textColor, `background-${_vm.type}`]},[_c('i',{}),_c('span',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.messageId, _vm.fillInData))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }